function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.4885172,20.994 L27.5124752,20.994 L27.5124752,4.554 L16.4885172,4.554 L16.4885172,20.994 Z M22,24.754 C21.274596,24.754 20.6871279,24.162 20.6871279,23.432 C20.6871279,22.701 21.274596,22.108 22,22.108 C22.7263964,22.108 23.3128721,22.701 23.3128721,23.432 C23.3128721,24.162 22.7263964,24.754 22,24.754 L22,24.754 Z M26.8128721,1 L17.1881202,1 C15.984406,1 15,1.992 15,3.204 L15,23.796 C15,25.009 15.984406,26 17.1881202,26 L26.8128721,26 C28.0165863,26 29,25.009 29,23.796 L29,3.204 C29,1.992 28.0165863,1 26.8128721,1 L26.8128721,1 Z",
  fill: "#FEFEFE"
}));

var SvgEmployeeMobilePhone = function SvgEmployeeMobilePhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "28px",
    viewBox: "0 0 45 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmployeeMobilePhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/employee-mobile-phone.58825aea.svg";
export { ForwardRef as ReactComponent };